







import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasTimeFieldTemplate from '@/fields/time/AmetrasTimeFieldTemplate.vue';

/**
 * General Component for Fields of type TIME with seconds
 *
 * https://confluence.ametras.com/x/L4RQAw
 */
@Component({
    components: {
        AmetrasTimeFieldTemplate
    },
    mixins: [BindAttrs]
})
export default class AmetrasTimeWithSecondsFieldTemplate extends Vue {
}
